<template>
    <ThLink :to="data.route">
        <ItemEngagementRing :data="data.ring" />
    </ThLink>
</template>

<script setup lang="ts">
import type { RingBuilderRingWithUrl } from '@/components/rings/ring-builder/RingBuilder.vue'

import ThLink from '@/components/ui/buttons/ThLink.vue'
import ItemEngagementRing from '@/components/rings/ring-builder/item/ItemEngagementRing.vue'

defineProps<{
    data: RingBuilderRingWithUrl
}>()
</script>
